import FlightDetailsAncillaryItem from "../../../../components/elements/FlightDetailsAncillaryItem/FlightDetailsAncillaryItem";
import { PlaneTicketReturnIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { t } from "@bookingcom/lingojs-core";
import React from "react";
import { useI18n } from "@bookingcom/lingojs-react";
import { UIProductFlexibleTicket } from "@flights/types";
import { getFlexibleTicketTotalUpgradePrice } from "../../../../components/elements/CheckoutTicketTypeInner/ticketTypeUtils";
import useFormatPrice from "../../../../hooks/useFormatPrice";

type FlexTicketItemProps = {
  showLoadingPrice?: boolean;
  flexibleTicket: UIProductFlexibleTicket;
  hasGeniusDeal?: boolean;
  /* start - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
  condensedFDDesktop?: boolean;
  condensedFDMobile?: boolean;
  /* end - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
};

const FlexTicketItem = ({
  showLoadingPrice,
  flexibleTicket,
  hasGeniusDeal,
  condensedFDDesktop,
  condensedFDMobile
}: FlexTicketItemProps) => {
  const { formatPrice } = useFormatPrice();
  const i18n = useI18n();

  const flexibleTicketTotalPrice = flexibleTicket && getFlexibleTicketTotalUpgradePrice(flexibleTicket);
  const flexibleTicketUpgradePrice = flexibleTicketTotalPrice ? formatPrice(flexibleTicketTotalPrice.total) : "";

  const flexibleTicketPriceStrikethrough =
    flexibleTicketTotalPrice &&
    flexibleTicketTotalPrice.showPriceStrikethrough &&
    flexibleTicketTotalPrice.totalWithoutDiscount
      ? formatPrice(flexibleTicketTotalPrice.totalWithoutDiscount)
      : undefined;

  const flexibleTicketPriceStrikethroughA11yText = !!flexibleTicketPriceStrikethrough
    ? i18n.trans(
        t("a11y_flights_fd_genius_flex_ticket_discounted_price_hint", {
          variables: {
            price_diff: flexibleTicketUpgradePrice,
            price_diff_without_discount: flexibleTicketPriceStrikethrough
          }
        })
      )
    : undefined;

  /* start - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
  const priceCopy =
    condensedFDDesktop || condensedFDMobile
      ? t("flights_fd_extras_condensed_flex_price", {
          variables: { price: formatPrice(flexibleTicketTotalPrice.total) }
        })
      : t("flights_apex_fd_extras_flex_ticket_price", {
          variables: { price_diff: flexibleTicketUpgradePrice || "" }
        });

  const condensedPriceStrikethrough =
    flexibleTicket.priceBreakdown?.showPriceStrikethrough && flexibleTicket.priceBreakdown?.totalWithoutDiscount
      ? formatPrice(flexibleTicket.priceBreakdown.totalWithoutDiscount)
      : undefined;
  /* end - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */

  return (
    <FlightDetailsAncillaryItem
      type="flexibleTicket"
      icon={PlaneTicketReturnIcon}
      showLoadingPrice={showLoadingPrice}
      title={i18n.trans(t("flights_apex_fd_extras_flex_ticket"))}
      description={i18n.trans(t("flights_apex_fd_extras_flex_ticket_description"))}
      priceCopy={i18n.trans(priceCopy)}
      priceStrikethrough={
        flexibleTicketPriceStrikethrough
          ? condensedFDDesktop || condensedFDMobile
            ? condensedPriceStrikethrough
            : i18n.trans(
                t("flights_apex_fd_extras_flex_ticket_original_price_strike_through", {
                  variables: { price_diff_without_discount: flexibleTicketPriceStrikethrough || "" }
                })
              )
          : undefined
      }
      priceStrikethroughA11yText={flexibleTicketPriceStrikethroughA11yText}
      isRecommended={flexibleTicket?.recommendation?.recommended}
      confidenceLevel={flexibleTicket.recommendation?.confidence}
      geniusDealBadges={hasGeniusDeal ? flexibleTicket.badges : undefined}
      /* start - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
      condensedFDDesktop={condensedFDDesktop}
      condensedFDMobile={condensedFDMobile}
      /* end - flights_web_condensed_extras_fd_ddot, flights_web_condensed_extras_fd_mdot */
    />
  );
};
export default FlexTicketItem;
